export interface IMasterDataProductUom {
  uomId: number;
  uomCode: string;
  uomName: string;
  uomDescription: string;
  isLinked: boolean;
  createdAt: string | null;
  createdBy: number | null;
}

export class MasterDataProductUom {
  private readonly _uomId: number;
  private readonly _uomCode: string;
  private readonly _uomName: string;
  private readonly _uomDescription: string;
  private readonly _isLinked: boolean;
  private readonly _createdAt: string | null;
  private readonly _createdBy: number | null;

  constructor(props: IMasterDataProductUom) {
    this._uomId = props.uomId;
    this._uomCode = props.uomCode;
    this._uomName = props.uomName;
    this._uomDescription = props.uomDescription;
    this._isLinked = props.isLinked;
    this._createdAt = props.createdAt;
    this._createdBy = props.createdBy;
  }

  get uomId(): number {
    return this._uomId;
  }
  get uomCode(): string {
    return this._uomCode;
  }
  get uomName(): string {
    return this._uomName;
  }
  get uomDescription(): string {
    return this._uomDescription;
  }
  get isLinked(): boolean {
    return this._isLinked;
  }
  get createdAt(): string | null {
    return this._createdAt;
  }
  get createdBy(): number | null {
    return this._createdBy;
  }

  static from(props: IMasterDataProductUom): MasterDataProductUom {
    return new MasterDataProductUom(props);
  }

  static toJSON(entity: MasterDataProductUom): IMasterDataProductUom {
    return {
      uomId: entity.uomId,
      uomCode: entity.uomCode,
      uomName: entity.uomName,
      uomDescription: entity.uomDescription,
      isLinked: entity.isLinked,
      createdAt: entity.createdAt,
      createdBy: entity.createdBy,
    };
  }
}

export interface IMasterDataProductUomDeleteResult {
  deletedCount: number;
  blockedCount: number;
  blockedIds: number[];
  message: string | null;
}
